import React from 'react';
import FormWrapper from '../common/FormGroup/FormWrapper';
import FormTextInput from '../common/FormGroup/FormTextInput';
import FormSlider from '../common/FormGroup/FormSlider';
import FormMarkDownEditor from '../common/FormGroup/FormMarkDownEditor';
import DefaultState, { IForecastGuidanceDefaultState } from './DefaultState';
import { FONT_SIZE_MARK_STYLE } from '../common/common';
import FormSwitch from '../common/FormGroup/FormSwitch';

export interface IForecastGuidanceConfigurator {
    staticBlockState: IForecastGuidanceDefaultState;
    setStaticBlockState: (staticBlockState: IForecastGuidanceDefaultState) => void;
    timezone: string;
}

const ForecastGuidanceConfigurator = ({ staticBlockState, setStaticBlockState, timezone }: IForecastGuidanceConfigurator) => {
    const { settings, title, content } = staticBlockState;
    const { fontSize, showBoxAround, showLastUpdated } = settings;

    const onTitleChange = (title: string) => {
        const newViewBlockState = { ...staticBlockState, title };
        setStaticBlockState(newViewBlockState);
    };

    const onFontSizeChange = (fontSize: number) => {
        const newViewBlockState = { ...staticBlockState, settings: { ...staticBlockState.settings, fontSize } };
        setStaticBlockState(newViewBlockState);
    };

    const onContentChange = (content: string) => {
        const lastUpdated = new Date().toString();
        const newViewBlockState = { ...staticBlockState, content, lastUpdated };

        setStaticBlockState(newViewBlockState);
    };

    const onShowLastUpdatedChange = (showLastUpdated: boolean) => {
        setStaticBlockState({
            ...staticBlockState,
            settings: {
                ...staticBlockState.settings,
                showLastUpdated,
            },
        });
    };

    const onShowBoxAroundChange = (showBoxAround: boolean) => {
        setStaticBlockState({
            ...staticBlockState,
            settings: {
                ...staticBlockState.settings,
                showBoxAround,
            },
        });
    };

    return (
        <div className='ForecastGuidanceConfiguration'>
            <FormWrapper>
                <FormTextInput label={'Title'} value={title} onChange={(title: string) => onTitleChange(title)} />
                <FormSlider
                    onChange={(fontSize: number) => onFontSizeChange(fontSize)}
                    value={fontSize}
                    label={'Font size'}
                    min={50}
                    max={150}
                    marks={{
                        50: { label: '50%', FONT_SIZE_MARK_STYLE },
                        100: { label: '100%', FONT_SIZE_MARK_STYLE },
                        150: { label: '150%', FONT_SIZE_MARK_STYLE },
                    }}
                />
                <FormSwitch
                    onChange={(showLastUpdated: boolean) => onShowLastUpdatedChange(showLastUpdated)}
                    label={'Show last updated date'}
                    unCheckedLabel='hide'
                    checkedLabel='show'
                    value={showLastUpdated}
                />
                <FormSwitch
                    onChange={(showBoxAround: boolean) => onShowBoxAroundChange(showBoxAround)}
                    label={'Show box around'}
                    value={showBoxAround}
                    unCheckedLabel='hide'
                    checkedLabel='show'
                />
                <FormMarkDownEditor
                    value={content}
                    defaultValue={DefaultState.content}
                    onChange={(content: string) => onContentChange(content)}
                    editorType={'FULL_EDITOR'}
                />
            </FormWrapper>
        </div>
    );
};

export default ForecastGuidanceConfigurator;
